<template>
  <div class="order-detail">
    <!-- 顶部导航栏 -->
    <div class="posflex">
      <van-nav-bar
        title="订单详情"
        left-arrow
        left-text="返回"
        @click-left="goBack"
        >x</van-nav-bar
      >
    </div>
    <!-- 主体 -->
    <div style>
      <div class="view" v-if="detail.orderStatus === '00'">
        <span style="color: #fff">订单已取消</span>
        <img
          style="height: 67px; width: 99px"
          src="https://file.sdyxmall.com/h5/v1/public/app/img/cancel.ff91da7.png"
          alt
        />
      </div>
      <div class="flex aic bg-fff pl-15" style="height: 40px">
        <!-- <van-icon name="location-o" />
        <div class="user-address-right flex2 ml-10">
          <p>
            <span>{{detail.addressInfo && detail.addressInfo.name}}</span>
            <span
              style="color:#797d82;"
              class="f14 ml-10 f999"
            >{{detail.addressInfo && detail.addressInfo.tel}}</span>
          </p>
          <p
            class="user-button-address mt-10 f14 f999"
          >{{detail.addressInfo && detail.addressInfo.address}}</p>
        </div> -->
      </div>
      <div class="orderGoods bg-fff pt-15">
        <van-card
          v-for="(item, index) in detail.carts"
          :key="index"
          :num="item.buyNum"
          :price="item.price | formatMoney"
          :title="item.masterName"
          :thumb="item.imgUrl"
          style="font-size: 15px"
        >
          <van-divider />
        </van-card>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          padding: 12px 15px;
          height: 98px;
          background: white;
        "
        class="payMoney"
      >
        <div
          style="
            line-height: 24px;
            flex-grow: 1;
            display: flex;
            justify-content: space-between;
          "
        >
          <span style="color: #797d82; font-size: 13px">商品金额</span>
          <span style="color: #2e2f30; font-size: 13px"
            >￥{{ detail.totalMoney | formatMoney }}</span
          >
        </div>
        <div
          style="
            line-height: 24px;
            flex-grow: 1;
            display: flex;
            justify-content: space-between;
          "
        >
          <span style="color: #797d82; font-size: 13px">运费</span>
          <span style="color: #2e2f30; font-size: 13px">￥0.00</span>
        </div>
        <div
          style="
            line-height: 24px;
            flex-grow: 1;
            display: flex;
            justify-content: space-between;
          "
        >
          <span>实付</span>
          <span style="color: #c03131"
            >￥{{ detail.allFee | formatMoney }}</span
          >
        </div>
      </div>
      <div
        style="
          padding: 12px 15px;
          color: #797d82;
          font-size: 11px;
          background: white;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="line-height: 22px">
            <span style="margin-right: 10px">订单编号</span>
            <span>{{ detail.orderId }}</span>
          </div>
          <div>
            <van-button type="default" size="mini">复制</van-button>
          </div>
        </div>

        <div>
          <span style="margin-right: 10px">下单时间</span>
          <span>{{ detail.updateTime | formatTime }}</span>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="fixl">
      <div style="padding-left: 12px" v-if="detail.orderStatus === '00'">
        订单状态: 已取消
      </div>
      <div style="padding-left: 12px" v-if="detail.orderStatus === '01'">
        订单状态: 已支付
      </div>
      <div
        class="flex"
        style="padding-left: 12px"
        v-if="detail.orderStatus === '02'"
      >
        <span class="mr-5">剩余支付时间:</span>
        <time-box class="f999" :createTime="detail.createTime"></time-box>
      </div>
      <div style="padding-right: 15px">
        <van-button
          style="font-size: 15px"
          type="default"
          size="small"
          v-if="detail.orderStatus === '00'"
          >重新购买</van-button
        >
        <van-button
          style="font-size: 15px"
          type="default"
          size="small"
          v-if="detail.orderStatus === '01'"
          @click="cancelOrder"
          >取消订单</van-button
        >
        <van-button
          @click="toPay"
          style="font-size: 15px"
          type="default"
          size="small"
          v-if="detail.orderStatus === '02'"
          >去支付</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import TimeBox from "@/components/TimeBox";
export default {
  components: {
    TimeBox,
  },
  data() {
    return {
      detail: {},
      from: "",
    };
  },

  created() {
    this.getOrderDetail();
  },

  beforeRouteEnter(to, from, next) {
    console.log(to.path, from.path);
    next((vm) => {
      vm.from = from.path;
    });
  },

  methods: {
    toPay() {
      let query = {
        qrcode: this.detail.qrcode,
        orderId: this.detail.orderId,
        createTime: this.detail.createTime,
        allFee: this.detail.allFee,
      };
      this.$router.push({ path: "/order/pay", query });
    },

    goBack() {
      if (this.from === "/order/list") {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },

    async cancelOrder() {
      try {
        this.$loading(true);
        let res = await this.$axios.post("/order/update", {
          orderId: this.detail.orderId,
          orderStatus: "00",
        });
        this.$loading(false);
        this.$dialog.alert({
          message: "取消成功",
        });
        this.detail.orderStatus = "00";
      } catch (error) {
        this.$fail(error);
        this.$loading(false);
      }
    },

    getOrderDetail() {
      let { orderId } = this.$route.params;
      let url = "/order/detail?orderId=" + orderId;
      this.$loading(true);
      this.$get(url)
        .then((res) => {
          this.detail = res.result;
          this.$loading(false);
        })
        .catch((err) => {
          this.$fail(err);
        });
    },
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>